$shm_surreal_table $mol_view
	profile_id \local
	table_name \benchmark_entity
	columns /
		\name
		\status
		\value
	search_fields /
	search? \
	filter_field? \
	filter_value? \
	page_index? 0
	page_size? \20
	sub /
		<= Toolbar $mol_view
			sub /
				<= Search $mol_string
					value? <=> search?
					hint \Поиск
				<= Filter_field $mol_select
					value? <=> filter_field?
					dictionary <= filter_fields *
					Filter null
				<= Filter_value $mol_string
					value? <=> filter_value?
					hint \Значение фильтра
				<= Reload $mol_button_minor
					title \Обновить
					click? <=> reload? null
		<= Status $mol_view
			sub / <= status_text \
		<= Grid $shm_surreal_table_grid
			head <= columns
			objects <= rows /
		<= Footer $mol_view
			sub /
				<= Count $mol_view
					sub / <= count_text \
				<= Page_size $mol_select
					value? <=> page_size?
					dictionary <= page_sizes *
					Filter null
				<= Paginator $mol_paginator
					value? <=> page_number?
	page_number? 1

$shm_surreal_table_grid $mol_grid
	head /string
	objects /any
	col_ids <= head
	Cell_text* $mol_grid_cell
		sub <= cell_content* /
